
<div class="flex justify-content-start align-items-center mt-4 gap-4" >
	<h1 class="" *ngIf="!api.adminOrder">Ma commande en cours</h1>
	
	<button pButton label="Ajout rapide" icon="pi pi-plus" (click)="api.displayFast = true" *ngIf="!api.adminOrder"></button>

	<div class="flex justify-content-start">
		<p-fileUpload #fubauto mode="basic" name="demo[]" accept=".csv,.txt"  (onSelect)="onFileChoose($event);fubauto.clear()" [auto]="true" chooseLabel="Import fichier" chooseIcon="pi pi-upload"></p-fileUpload>
		<i class="pi pi-info-circle cursor-pointer text-2xl ml-2" (click)="op.show($event)"></i>
	</div>

	<p-overlayPanel #op>
		<ng-template pTemplate>
			Fichier .txt ou .csv<br/>
			Une ligne par article : <br/> 
			<p class="font-italic text-500">
				Référence ou EAN, quantité
			</p>
			<p-panel header="Exemple" styleClass="text-500">
				DRO0014PA;1<br/>
				FLI016RI;2<br/>
				3770010367154;12<br/>
				GRR019NI;3<br/>
				NUT024MI;1<br/>
			</p-panel>
		</ng-template>
	</p-overlayPanel>
</div>

<div *ngIf="api.adminOrder">
</div>

<p-table [value]="api.order.prods" responsiveLayout="scroll" styleClass="p-datatable-gridlines">
	<ng-template pTemplate="header">
		<tr *ngIf="api.adminOrder">
			<th colspan="2" class="flex justify-content-between align-items-center">
				<div>
					<p-dropdown
						[options]="['brg','editeur']"
						[(ngModel)]="api.order.dotation"
						[placeholder]="isDotationRequired() ? 'Dotation *' : 'Dotation'"
						[styleClass]="isDotationRequired() && !api.order.dotation ? 'ng-invalid ng-dirty' : ''"
						appendTo="body"></p-dropdown>
					<small *ngIf="isDotationRequired() && !api.order.dotation" class="p-error block mt-1">
						Champ Dotation obligatoire
					</small>
				</div>
				<input type="text" pInputText [(ngModel)]="api.order.xx_Code_Festival" placeholder="Code Événement" />
			</th>
			<th colspan="3">
				<input size="30" type="text" pInputText  [(ngModel)]="api.order.ThirdOrderNumber" placeholder="N° de commande client" />
			</th>
			<th colspan="3" >
				<p-dropdown  [(ngModel)]="api.order.payment.Id" optionValue="Id" optionLabel="Caption" [options]="api.payment" placeholder="Méthode de réglement" appendTo="body"></p-dropdown>
			</th>
		</tr>
		<tr >
			<th>Nom</th>
			<th>Prix brut</th>
			<th [ngClass]="{'w-11rem':api.adminOrder}">Remise</th>
			<th>Prix net</th>
			<th>Quantité</th>
			<th>Total HT</th>
			<th>TVA</th>
			<th>Total TTC</th>
		</tr>
	</ng-template>
	<ng-template pTemplate="body" let-row>
		<tr [ngClass]="{'surface-100':row.offerName && row.gift,'bg-red-700':row.rupture,'bg-orange-900':row.hasLimitedQty}">
			<td class="">
				<div class="flex align-items-center justify-content-between">
					<a class="text-white" [routerLink]="['/game/'+row.Id]" *ngIf="!api.adminOrder">{{row.name}}</a>
					<u class="text-white" *ngIf="api.adminOrder">{{row.name}}</u>
					<i class="font-bold flex align-items-center gap-2" *ngIf="row.type == 'text' && row.Id != 'TXT'  && row.Id != 'TXT00080'">
						<span>{{row.StandardTextClear}}</span>
					</i>
					<input class="flex-grow-1" type="text" pInputText placeholder="Information prépa" [(ngModel)]="row.StandardTextClear" *ngIf="row.Id == 'TXT'"/>
					<input class="flex-grow-1" type="text" pInputText placeholder="Information client" [(ngModel)]="row.StandardTextClear"
						*ngIf="row.Id == 'TXT00080'" />
					<div *ngIf="api.adminOrder && row.type != 'text' && row.quantity > 0" >
						<p-button *ngIf="!row.gift && !row.duplicate" pTooltip="Dupliquer le produit" icon="pi pi-copy" styleClass="p-button-sm p-button-info " (click)="duplicate(row)"></p-button>
						<p-dropdown (onChange)="textAdded.emit(row)" [(ngModel)]="row.lineText" appendTo="body" [options]="lineTexts" placeholder="Cas part." optionLabel="Caption" [filter]="false" styleClass="w-10rem ml-2"></p-dropdown>
					</div>
				</div>
				<div class="text-xs" *ngIf="row.offerName">
					{{row.offerName}}
				</div>
				<div class="text-xs text-white font-bold flex align-items-center gap-2 mt-1" *ngIf="row.hasLimitedQty">
					<i class="pi pi-exclamation-triangle"></i>
					<span>{{row.limitMessage}}</span>
				</div>
				<button (click)="row.quantity = row.giftQty;api.totalOrder()" pButton label="Je souhaite bénéficier de cette offre" class="text-xs p-0 px-2 p-button-success p-button-outlined" *ngIf="row.gift && row.offerName && row.discountRate != 100 && row.quantity === 0"></button>
				<button (click)="row.quantity = 0;api.totalOrder()" pButton label="Je ne souhaite pas bénéficier de cette offre" class="text-xs p-0 px-2 p-button-danger p-button-outlined" *ngIf="row.gift && row.offerName && row.discountRate != 100 && row.quantity > 0"></button>
			</td>
			<td>
				<span *ngIf="!api.adminOrder">{{row.priceHT | currency:'EUR'}}</span>
				<p-inputNumber *ngIf="api.adminOrder" mode="decimal" [minFractionDigits]="2" inputStyleClass="w-6rem"  [(ngModel)]="row.priceHT" (onInput)="api.totalOrder()"></p-inputNumber>
			</td>
			<td >
				<div *ngIf="api.adminOrder && row.type != 'text'" class="flex justify-content-start gap-2 align-items-center">
					<div  >
						<div class="p-inputgroup" >
							<p-inputNumber [min]="-100" [max]="100" mode="decimal" [minFractionDigits]="2" inputStyleClass="w-6rem"  [(ngModel)]="row.discountRateSupp" (onInput)="api.totalOrder()"></p-inputNumber>
							<!-- <input type="text" pInputText placeholder="Remise supp." [(ngModel)]="row.discountRateSupp"/> -->
							<span class="p-inputgroup-addon">%</span>
						</div>
					</div>
					<div>{{row.discountRate}}%</div>
				</div>
				<div *ngIf="!api.adminOrder">{{row.discountRate}}%</div>
			</td>
			<td>{{row.priceHT  - row.discountAmount | currency:'EUR'}}</td>
			<td>
				<div class="flex align-items-center">
					<p-inputNumber [step]="row.step" *ngIf="row.type != 'text'" [disabled]="row.gift" (onInput)="row.quantity = $event.value;api.changeQty(row)" (onBlur)="api.roundToStep(row)" [showButtons]="true" buttonLayout="horizontal" spinnerMode="horizontal" [min]="0" inputStyleClass="w-3rem text-center py-1 px-1 border-transparent" [(ngModel)]="row.quantity" 
					class="border-1 surface-border border-round" decrementButtonClass="p-button-text py-1 px-1" incrementButtonClass="p-button-text py-1 px-1" incrementButtonIcon="pi pi-plus" decrementButtonIcon="pi pi-minus"></p-inputNumber>
					<p-button *ngIf="api.adminOrder" icon="pi pi-trash" styleClass="p-button-sm p-button-danger ml-2" (click)="row.quantity = 0;api.changeQty(row)"></p-button>
				</div>
			</td>
			<td>{{(row.priceHT- row.discountAmount) * row.quantity | currency:'EUR'}}</td>
			<td><span *ngIf="row.type != 'text'" >{{row.Rate}}%</span></td>
			<td>{{(row.priceHT - row.discountAmount) * row.quantity + row.TotalVatAmount | currency:'EUR'}}</td>
		</tr>
	</ng-template>
	<ng-template pTemplate="footer">
		<tr><th colspan="8" class="p-2"></th></tr>
		<tr>
			<td colspan="5" rowspan="5">
				<div class="mb-2">Vous pouvez ajouter des notes à votre commande </div>
				<textarea [(ngModel)]="api.order.notes" pInputTextarea class="w-full h-8rem" ></textarea>

			</td>
			<td colspan="2">TOTAL HT</td>
			<td align="right">
				{{api.order.sumHT | currency:'EUR'}}
			</td>
		</tr>
		<tr>
			<td colspan="2">TOTAL TVA</td>
			<td align="right">
				{{(api.order.sumTTC - api.order.sumHT) | currency:'EUR'}}
			</td>
		</tr>
		<tr>
			<td colspan="2">
				<div>FRAIS DE PORT</div>
				<p-checkbox label="Offert" [(ngModel)]="api.order.freeShipping" (onChange)="api.totalOrder()" [binary]="true"></p-checkbox>
			</td>
			<td align="right">
				{{(api.order.shipping) | currency:'EUR'}}
			</td>
		</tr>
		<tr >
			<ng-container *ngIf="api.order.DiscountRate > 0">
				<td colspan="2">
					<div>remise : {{api.order.DiscountRate | number:'1.2-2'}}% soit</div>
				</td>
				<td align="right">
					{{(api.order.DiscountAmount) | currency:'EUR'}}
				</td>
			</ng-container>
		</tr>
		<tr>
			<td colspan="2">TOTAL TTC</td>
			<td align="right">
				{{api.order.sumTTC + api.order.shipping - api.order.DiscountAmount| currency:'EUR'}}
			</td>
		</tr>
		<tr><th colspan="8" class="p-2"></th></tr>


	</ng-template>
</p-table>
<div class="pt-4 text-right" *ngIf="api.order.sumTTC < 100 && !api.adminOrder">
	<p-message severity="warn" text="Le montant minimal de commande est de 100 €" styleClass=""></p-message>  
</div>
<div class="pt-4 text-right" *ngIf="hasAnyQuantityLimitExceeded()">
	<p-message severity="error" text="Certains produits dépassent la quantité maximale autorisée. Veuillez ajuster les quantités avant de valider." styleClass=""></p-message>  
</div>
<div class="pt-4 text-right" *ngIf="hasUnavailableProducts()">
	<p-message severity="error" text="Certains articles ne sont plus disponibles (lignes en rouge). Retirez-les avant de valider la commande." styleClass=""></p-message>
</div>
<div class="pt-4 text-right" *ngIf="isDotationRequired() && !api.order.dotation">
	<p-message severity="error" text="Le champ Dotation n'est pas renseigné. Sélectionnez « brg » ou « editeur » pour valider la commande." styleClass=""></p-message>
</div>
<div class="flex justify-content-end gap-3 pt-3" >
	<button *ngIf="api.order.prods.length > 0" (click)="api.clearCart()" pButton pRipple icon="pi pi-trash" label="Vider mon panier" class="p-button-danger p-button-outlined "></button>
	<button [disabled]="api.order.prods.length === 0 || api.order.prods == []" pButton pRipple icon="pi pi-save" (click)="saveOrder()" label="Enregistrer pour plus tard" class="p-button-outlined "></button>
	<button [disabled]="api.order.prods.length === 0 || api.order.prods == [] || (!api.isDevMode() && api.order.sumTTC < 100 && !api.adminOrder) || hasAnyQuantityLimitExceeded() || (!api.adminOrder && hasUnavailableProducts()) || (isDotationRequired() && !api.order.dotation)" pButton pRipple icon="pi pi-check" (click)="dialogConfim = true;" label="Valider ma commande" class=""></button>
</div>


<p-dialog [(visible)]="dialogConfim" appendTo="body" [modal]="true" [closable]="false" [showHeader]="false" (onShow)="refresh()" [position]="api.adminOrder ? 'bottom' : 'center'">
	<div class="flex align-items-center my-4">
		<span class="flex align-items-center justify-content-center bg-cyan-100 text-cyan-800 mr-3 border-circle mb-3" style="width:64px;height:64px">
			<i class="pi pi-home text-5xl"></i>
		</span>
		<div class="font-medium text-2xl text-900">Adresse de livraison</div>
	</div>
	<div class="text-center">
		<p-dropdown [appendTo]="'body'" [options]="addresses" [(ngModel)]="addressChoosed"></p-dropdown>
		<p *ngIf="!api.adminOrder"><a [routerLink]="['/mon-compte']" (click)="dialogConfim = false" >Gérer mes adresses</a></p>
	</div>
	<div class="flex align-items-center my-4" *ngIf="!api.adminOrder">
		<span class="flex align-items-center justify-content-center bg-cyan-100 text-cyan-800 mr-3 border-circle mb-3" style="width:64px;height:64px">
			<i class="pi pi-check text-5xl"></i>
		</span>
		<div class="font-medium text-2xl text-900">Je confirme l'envoi de ma commande</div>
	</div>
	<div *ngIf="!api.adminOrder">
		<p class="line-height-3 text-center">Votre commande va être envoyée à votre commercial référent.</p>
		<p class="line-height-3 text-center">Vous pouvez suivre l'évolution de votre commande depuis <a [routerLink]="['/mes-commandes']">votre compte</a></p>
		<p class="line-height-3 text-center">La commande peut mettre quelques minutes avant d'apparaitre dans la listes de vos commandes</p>
	</div>
	<div *ngIf="api.adminOrder" class="my-3">
		<p-radioButton name="devis" [value]="true" [(ngModel)]="api.order.devis" label="Devis"></p-radioButton>
		<p-radioButton name="devis" [value]="false" [(ngModel)]="api.order.devis" label="Commande" styleClass="ml-3"></p-radioButton>
		<div *ngIf="api.order.devis" class="mt-3 flex flex-column align-items-center">
			<div class="font-medium text-2xl text-900">
				Date de livraison souhaitée
			</div>
			<p-message *ngIf="api.order.totWeight < 50" severity="warn" text="Le devis sera transféré automatiquement en commande 2 jours avant cette date"></p-message> 
			<p-message *ngIf="api.order.totWeight >= 50" severity="warn" text="Le devis sera transféré automatiquement en commande 5 jours avant cette date"></p-message> 
			<p-calendar dateFormat="dd/mm/yy" (onSelect)="api.order.DeliveryDate.setHours(12)" [inline]="true" name="DeliveryDate" [(ngModel)]="api.order.DeliveryDate"></p-calendar>
		</div>
	</div>
	<ng-template pTemplate="footer">
		<div class=" border-top-1 surface-border py-3 flex">
			<button pButton pRipple icon="pi pi-times" (click)="dialogConfim = false" label="Annuler" class="p-button-outlined w-6 mr-2"></button>
			<button pButton pRipple icon="pi pi-check" (click)="dialogConfim = false;send()" label="Envoyer" class="w-6 ml-2"></button>
		</div>
		<p-message *ngIf="api.order.edit && api.order.devis === false" severity="info" text="Le devis sera enregistré et transféré automatiquement en commande"></p-message> 
	</ng-template>
</p-dialog>

<p-dialog (onHide)="fastOrder()" contentStyleClass="bg-white p-2" styleClass="fast-order" [(visible)]="api.displayFast" appendTo="body" [modal]="true" [closable]="true" [header]="'Sélectionnez les jeux'" [contentStyle]="{height: '100vh'}">
	<app-fast-order *ngIf="api.displayFast" ></app-fast-order>
</p-dialog>